import config from "config/config";
export const getImage = (imageName) => {
  return `${config.REG_API_BASE_URL}/User/document?FileName=${config.COMPANY_NAME}_${imageName}&Display=inline`;
};
